import { useEffect } from "react";

export type CssVars<T extends `--${string}` = `--${string}`> = Record<T, string>;

export function useCssVars(cssVars: CssVars, dependencies: React.DependencyList = [cssVars]) {
  useEffect(() => {
    setCssVars(cssVars);

    return () => removeCssVars(cssVars);
  }, dependencies);
}

export function setCssVars(cssVars: CssVars) {
  const isEmptyObject = Object.keys(cssVars).length === 0;
  if (isEmptyObject) {
    return;
  }

  return Object.entries(cssVars).forEach(([key, value]) =>
    document.documentElement.style.setProperty(key, value),
  );
}

export function removeCssVars(cssVars: CssVars) {
  return Object.entries(cssVars).forEach(([key]) =>
    document.documentElement.style.removeProperty(key),
  );
}
